<template>
  <div style="background-color: #fe5759">
    <div class="act-bg">
      <div class="act-header">
        <img class="act-main-title" :src="baseUrl + 'titletext.png' + '?' + nowDate" />
        <img class="act-sub-title" :src="baseUrl + 'titlecenter.png' + '?' + nowDate" />
        <img class="act-tip-title" :src="baseUrl + 'titletip.png' + '?' + nowDate" />
      </div>
      <div class="act-area" v-for="index in areaList">
        <img class="act-area-title" :class="{ 'title02': index.titleBg === 'title02.png' }"
          :src="baseUrl + index.titleBg + '?' + nowDate" />
        <div class="act-goodsInfo" v-for="item in index.goodsList" @click="toGoodsDetail(item.goodsId)">
          <img class="goodsImg" :src="baseUrl + item.goodsImg + '?' + nowDate" alt="" />
        </div>
      </div>
      <img class="logoImg" :src="baseUrl + logoImg + '?' + nowDate" alt="" />
    </div>
  </div>
</template>
<script>
import { getDetail } from "@/utils/api/vipEnjoyApi";
import { toGoodsDetail } from "@/utils/InteractionWithJs";
import { addLog } from "../../../utils/commonApi";
import {getUrlQueryValueByKey} from "@/utils/util";

export default {
  data() {
    return {
      nowDate: new Date().getTime(),
      logoImg: 'logo.png',
      baseUrl:
        "https://zhongsheng-prod-beijing.oss-cn-beijing.aliyuncs.com/app/h5act/20231111/butie/",
      areaList: [
        {
          titleBg: "title01.png",
          goodsList: [{
            goodsImg: "actgood1.png",
            goodsId: 10554845
          }],
        },
        {
          titleBg: "title4.png",
          goodsList: [{
            goodsImg: "actgoods12.png",
            goodsId: 10555016
          }],
        },
        {
          titleBg: "title02.png",
          goodsList: [
            {
              goodsImg: "actgood2.png",
              goodsId: 10876426
            },
            {
              goodsImg: "actgood3.png",
              goodsId: 10846123
            },
          ],
        },
        {
          titleBg: "title3.png",
          goodsList: [
            {
              goodsImg: "actgood4.png",
              goodsId: 10875195
            },
            {
              goodsImg: "actgood5.png",
              goodsId: 10875205
            },
            {
              goodsImg: "actgood6.png",
              goodsId: 10875206
            },
            {
              goodsImg: "actgood7.png",
              goodsId: 10878053
            },
            {
              goodsImg: "actgood8.png",
              goodsId: 10875713
            },
            {
              goodsImg: "actgood9.png",
              goodsId: 10875714
            },
            {
              goodsImg: "actgood10.png",
              goodsId: 10875762
            },
            {
              goodsImg: "actgood11.png",
              goodsId: 10875763
            },
          ],
        },
      ],
    };
  },
  mounted() {
    // this.getDetail()
    const actId = getUrlQueryValueByKey(location.href, "actId") || getUrlQueryValueByKey(location.href, "pageFlg") || '';
    const accessRefer = getUrlQueryValueByKey(location.href, "accessRefer") || '';
    //埋点
    addLog(accessRefer, '23-11-2', actId);
  },
  methods: {
    toGoodsDetail(goodsId) {
      toGoodsDetail(0,goodsId)
    },
    async getDetail() {
      const { errno, data, errmsg } = await getDetail();
      if (!errno) {
        this.goodsList = data;
      }
    },
  },
};
// document.title = "订阅会员尊享";
</script>
<style scoped>
.act-bg {
  background-image: url("https://zhongsheng-prod-beijing.oss-cn-beijing.aliyuncs.com/app/h5act/20231111/butie/butiebg.png");
  width: 100%;
  background-size: 100%;
  background-repeat: no-repeat;
  min-height: 100vh;
  z-index: 0;
}

.act-header {
  width: 80%;
  margin-left: 10%;
}

.act-main-title {
  margin-top: .5rem;
  width: 2.12rem;
}

.act-sub-title {
  margin-top: .13rem;
  width: 6.09rem;
}

.act-tip-title {
  width: 6rem;
}

.act-goodslist {
  display: flex;
  flex-direction: column;
}

.act-area {
  position: relative;
  width: 100%;
  padding-bottom: 10px;
  padding-top: 10px;
  margin-top: .6rem;
  z-index: 1;
}

.act-area::before {
  content: "";
  position: absolute;
  top: 0;
  left: 5px;
  /* distance to the left side */
  right: 5px;
  /* distance to the right side */
  bottom: 0;
  background-color: rgba(187, 28, 34, 0.7);
  border-radius: 5px;
  z-index: -1;
}

.act-area .act-area-title {
  width: 230px;
  /* height: 24px; */
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
}

.act-area .title02 {
  width: 180px;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
}

.act-goodsInfo .goodsImg {
  width: 95%;
}

.act-goodsInfo .goodsName {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  font-size: 14px;
  margin-bottom: 0.1rem;
}

.act-goodsInfo .goodsValue {
  color: #666;
  font-size: 10px;
  margin-bottom: 0.5rem;
}

.act-goodsInfo .goodsPart {
  display: flex;
  align-items: center;
  position: relative;
}

.act-goodsScore {
  margin-right: 0.2rem;
  color: #ff9000;
}

.act-goodsScore img {
  width: 0.18rem;
  height: 0.19rem;
}

.act-btn {
  width: 1.1rem;
  height: 0.6rem;
  line-height: 0.6rem;
  background-color: #000;
  text-align: center;
  color: #fff;
  border-radius: 15px;
  font-size: 14px;
  position: absolute;
  right: 0.2rem;
}

.logoImg {
  width: 1.03rem;
  margin: .5rem auto;
}</style>
